// extracted by mini-css-extract-plugin
export default {"inputCheckbox":"InputCheckbox_inputCheckbox__j930k","labelCheckbox":"InputCheckbox_labelCheckbox__GGq7s"};